module.exports = __webpack_public_path__ + "static/media/lung_capture_black.5ba96b99.png";